var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVennIntersection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "620px",
    height: "620px",
    viewBox: "0 0 620 620",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "venn-intersection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "venn-intersection",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.469652,151.361961 C341.306428,130.31069 378.59504,118 418.760258,118 C524.892316,118 610.939303,203.955824 610.939303,310 C610.939303,416.044176 524.892316,502 418.760258,502 C378.59504,502 341.306428,489.68931 310.469652,468.638039 C279.63287,489.689311 242.344261,502 202.179045,502 C96.0469868,502 10,416.044176 10,310 C10,203.955824 96.0469868,118 202.179045,118 C242.344261,118 279.63287,130.310689 310.469645,151.361956 L310.469652,151.361961 Z M274.683163,183.615223 C253.327665,171.36768 228.572766,164.364121 202.179045,164.364121 C121.642188,164.364121 56.3641208,229.573029 56.3641208,310 C56.3641208,390.426971 121.642188,455.635879 202.179045,455.635879 C228.572766,455.635879 253.327665,448.63232 274.683163,436.384777 C245.104489,402.616442 227.179303,358.40061 227.179303,310 C227.179303,261.59939 245.104489,217.383558 274.683163,183.615223 L274.683163,183.615223 Z M346.654518,183.387583 L346.654518,183.387583 C376.352198,217.184728 394.35809,261.490555 394.35809,310 C394.35809,358.509445 376.352198,402.815272 346.654518,436.612417 C367.919259,448.719062 392.530496,455.635879 418.760258,455.635879 C499.297115,455.635879 564.575183,390.426971 564.575183,310 C564.575183,229.573029 499.297115,164.364121 418.760258,164.364121 C392.530496,164.364121 367.919259,171.280938 346.654518,183.387583 Z",
    id: "Combined-Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVennIntersection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/venn-intersection.67b72bd1d84a0d20aecb9e0cf4a08b8d.svg";